import { ViewHeader2Page } from "./../view-header2/view-header2";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { WaitStep2Page } from "./../wait-step2/wait-step2";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-merchant-select-team",
  templateUrl: "merchant-select-team.html",
})
export class MerchantSelectTeamPage {
  merchantActive = "";
  plaza_id = "";
  merchant_id = "";
  theme = 1;

  constructor(
    private services: ServiceProvider,
    private http: Http,
    private navCrl: NavController,
    private translateService: TranslateService,
    private storage: Storage,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.storage.get("info").then((info) => {
      this.merchantActive = info.team.merchant_name;
      this.merchant_id = info.team.merchant_id;
      // this.plaza_id = "A";

      if (info.team.plaza_id == 1) {
        this.plaza_id = "A";
      } else if (info.team.plaza_id == 2) {
        this.plaza_id = "B";
      } else if (info.team.plaza_id == 3) {
        this.plaza_id = "C";
      } else if (info.team.plaza_id == 4) {
        this.plaza_id = "D";
      } else if (info.team.plaza_id == 5) {
        this.plaza_id = "E";
      } else if (info.team.plaza_id == 6) {
        this.plaza_id = "F";
      }
    });
  }

  next() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var headers = new Headers();
      headers.append("Content-Type", "application/x-www-form-urlencoded");
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      var link3 = this.services.URLUserInfo;
      var headers2 = new Headers();
      headers2.append("Accept", "application/json");
      headers2.append("Authorization", "Bearer " + token);
      const requestOptions2 = new RequestOptions({ headers: headers2 });

      this.http
        .get(link3, requestOptions2)
        .map((res) => res.json())
        .subscribe(
          (res) => {
            this.storage.set("info", res);

            var link2 = this.services.URLUserStatEnd;
            this.http
              .post(link2, "", requestOptions)
              .map((res) => res.json())
              .subscribe((data2) => {
                this.storage.set("stepGame", "waitStep2");
                loader.dismiss();
                this.navCrl.push(WaitStep2Page);
              });
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  openHeadPage() {
    this.navCrl.push(ViewHeader2Page);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-select-team/merchant-select-team.ts